import { useLocation } from "react-router-dom";

/**
 * Decides which navigation chrome to show based on the current location.
 * Auth pages + landing page use the Landing nav; all others get the main nav.
 */
export const useNavVariant = () => {
  const { pathname } = useLocation();
  const showLanding = pathname === "/" || !pathname.startsWith("/recording");
  return showLanding ? "landing" : "main";
};
